import { IconPlus } from '@tabler/icons-react';
import React from 'react';
import "./Style.css";

const BusinessCardTablePreview = ({ pageData, blocksData }) => {

    return (
        <div className={`w-[100px] ms-auto h-[180px] rounded-xl border-2 overflow-hidden flex flex-col relative`}
            style={{
                fontFamily: pageData?.textOption?.font,
                backgroundColor: pageData?.backgroundOption?.color ? pageData?.backgroundOption?.color : pageData?.backgroundOption?.image ? 'unset' : '#ECECF2',
                backgroundRepeat: 'no-repeat',
                backgroundImage: pageData?.backgroundOption?.gradient?.length ? `linear-gradient(${pageData?.backgroundOption?.gradientAngle} ,${pageData?.backgroundOption?.gradient[0]}, ${pageData?.backgroundOption?.gradient[1]})` : pageData?.backgroundOption?.image ? `url(${(pageData?.backgroundOption?.image)})` : 'unset',
                backgroundSize: pageData?.backgroundOption?.image ? 'cover' : 'unset',
                backgroundPosition: pageData?.backgroundOption?.image ? 'center' : 'unset',
            }}>

            <div className="flex flex-col gap-3 flex-1">
                <div className={`flex flex-1 flex-col !gap-4`}>
                    {
                        blocksData?.map((block, index) => {
                            return (
                                <div key={index}>
                                    {block?.blockType == 1 && (
                                        pageData?.templateNumber == 1 ? <Head1 blockData={block} designData={pageData} /> : pageData?.templateNumber == 2 ? <Head2 blockData={block} designData={pageData} /> : <div className='h-3'></div>
                                    )}
                                    {block?.blockType == 6 && <LinkComponent blockData={block} designData={pageData} />}
                                </div>
                            )
                        })
                    }
                </div>
                <div className="flex order-3 items-center justify-center">
                    <div className="aspect-square bg-white flex items-center justify-center rounded-full p-0.5 shadow-md">
                        <img src={process.env.PUBLIC_URL + "/images/icon-logo.png"} className='h-2' alt="" />
                    </div>
                </div>
            </div>

            {pageData?.floatingButtonStatus && <button className='sticky right-2 bottom-2 flex items-center gap-3 py-1.5 pe-1.5 ps-3 text-sm font-semibold ms-auto rounded-full text-white' style={{ backgroundColor: pageData?.backgroundOption?.primaryColor }}>{pageData?.floatingButtonText || 'Add to Contact'} <div className='bg-white rounded-full p-2'> <IconPlus color='black' size={20} /> </div></button>}
        </div>
    )
}

export default BusinessCardTablePreview;

export const Head1 = ({ designData, blockData }) => {
    return (
        <div className='h-[180px] !px-4 py-2 flex flex-col justify-end items-start' style={{
            backgroundImage: (blockData?.profilePhoto && blockData?.profilePhotoStatus) ? `linear-gradient(to top, ${designData?.backgroundOption?.color || '#000000'} 5%, transparent 60%) ,url(${(blockData?.profilePhoto)})` : 'unset',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
        }}>
            {<p className='text-[10px] font-bold capitalize !mb-2' style={{ color: designData?.textOption?.titleColor ? designData?.textOption?.titleColor : '#070707' }}>{blockData?.name ?? "Welcome"}</p>}
            {blockData?.heading && <p className='mb-1.5 text-[8px] font-medium' style={{ color: designData?.textOption?.descriptionColor ? designData?.textOption?.descriptionColor : '#526281' }}>{blockData?.heading}</p>}
            {blockData?.subHeading && <p className='mb-2.5 text-[9px] font-semibold' style={{ color: designData?.textOption?.descriptionColor ? designData?.textOption?.descriptionColor : '#526281' }}>{blockData?.subHeading}</p>}
            {(blockData?.brandLogo && blockData?.brandLogoStatus) && <img src={blockData?.brandLogo} className='max-h-[20px] max-w-[60px]' alt="" />}
        </div>
    )
}

export const Head2 = ({ designData, blockData }) => {
    return (
        <>
            <div className='h-[160px] flex flex-col justify-end items-start relative' style={{
                backgroundImage: (blockData?.profilePhoto && blockData?.profilePhotoStatus) ? `url(${(blockData?.profilePhoto)})` : `linear-gradient(to top, ${designData?.backgroundOption?.color} 5%, transparent 60%)`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
            }}>
                {(blockData?.brandLogo && blockData?.brandLogoStatus) && <div className='h-[10px] w-[10px] absolute bottom-1 left-2 text-center m-auto'> <img src={blockData?.brandLogo} className='w-full h-full object-contain' alt="" /></div>}

                <svg version="1.1" className="qrc_profile_5_svg" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 375 171" style={{ enableBackground: 'new 0 0 375 171' }} xmlSpace="preserve">
                    <style type="text/css" dangerouslySetInnerHTML={{ __html: `.st0{fill:${designData?.backgroundOption?.primaryColor ?? '#212121'};}.st1{fill:${designData?.backgroundOption?.color ?? 'black'};}` }} />
                    <path id="Path_1445" className="st0" d="M1.06,84.91c0,0,96.52,77.37,187.89-7.93C310.63-48.31,375.49,23.64,375.49,23.64l-0.28,127.04
                                   H0.2" />
                    <path id="Path_1446" className="st1" d="M0.2,86.33c0,0,101.34,82.28,192.71-3.03C314.6-41.98,375.2,66.77,375.2,66.77v103.91H0.2V86.33
                                   z" />
                </svg>

            </div>

            <div className='!px-4 -mt-10 !pb-3 relative' style={{ backgroundColor: designData?.backgroundOption?.color }}>
                {<p className='text-[10px] font-bold capitalize' style={{ color: designData?.textOption?.titleColor ? designData?.textOption?.titleColor : '#070707' }}>{blockData?.name ?? "Welcome"}</p>}
                {blockData?.heading && <p className='text-[8px] font-medium' style={{ color: designData?.textOption?.descriptionColor ? designData?.textOption?.descriptionColor : '#526281' }}>{blockData?.heading}</p>}
                {blockData?.subHeading && <p className='text-[9px] font-semibold' style={{ color: designData?.textOption?.descriptionColor ? designData?.textOption?.descriptionColor : '#526281' }}>{blockData?.subHeading}</p>}
            </div>
        </>
    )
}

export const LinkComponent = ({ blockData, designData }) => {
    return (
        <div className='!mx-3 px-4 py-2 flex items-center justify-center gap-3' style={{
            backgroundColor: designData?.blocksOption?.background,
            borderRadius: designData?.blocksOption?.borderRadius,
            boxShadow: designData?.blocksOption?.shadowSize == "none" ? 'none' : `3px 6px ${designData?.blocksOption?.shadowSize == "medium" ? 2 : 10}px 0px rgba(0,0,0,0.58)`,
            borderWidth: designData?.blocksOption?.border,
            borderStyle: 'solid',
            borderColor: designData?.blocksOption?.borderColor
        }}>
            {blockData?.image && <img src={blockData?.image && (blockData?.image)} alt="" className='h-12 w-12 aspect-square rounded-lg object-cover' />}
            <div className='w-full text-center'>
                {blockData?.title && <p className='mb-0 text-md font-semibold capitalize' style={{ color: designData?.blocksOption?.titleColor ? designData?.blocksOption?.titleColor : '#070707' }}>{blockData?.title}</p>}
                {blockData?.description && <p className='mb-0 text-xs font-normal' style={{ color: designData?.blocksOption?.descriptionColor ? designData?.blocksOption?.descriptionColor : '#526281' }}>{blockData?.description}</p>}
            </div>
        </div>


    )
}